import { render } from "./PpcBASBBudgetCell.vue?vue&type=template&id=5c4c0950&scoped=true"
import script from "./PpcBASBBudgetCell.vue?vue&type=script&lang=js"
export * from "./PpcBASBBudgetCell.vue?vue&type=script&lang=js"

import "./PpcBASBBudgetCell.vue?vue&type=style&index=0&id=5c4c0950&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4c0950"]])

export default __exports__